
export default function B2BSection() {
  const b2bServices = [
    {
      icon: 'ri-file-text-line',
      title: 'Materiały sprzedażowe PL',
      description: 'Gotowe materiały w języku polskim: broszury, zdjęcia wysokiej rozdzielczości, opisy pokoi i usług.'
    },
    {
      icon: 'ri-image-line',
      title: 'Galeria zdjęć',
      description: 'Dostęp do profesjonalnej galerii zdjęć hotelu, golfa i okolicy do wykorzystania w materiałach promocyjnych.'
    },
    {
      icon: 'ri-ship-line',
      title: 'Wsparcie logistyczne',
      description: 'Pomoc w organizacji transferów, promów i całej logistyki dojazdu dla grup i indywidualnych gości.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Szybkie odpowiedzi',
      description: 'Dedykowany kontakt B2B z szybkim czasem odpowiedzi na zapytania i oferty dla agencji.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Specjalne ceny B2B',
      description: 'Atrakcyjne ceny dla agencji, pakiety grupowe i specjalne warunki współpracy.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Wizyty studyjne',
      description: 'Możliwość organizacji wizyt studyjnych dla agentów – poznaj hotel osobiście.'
    }
  ];

  return (
    <section id="b2b" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            Strefa B2B
          </h2>
          <div className="w-24 h-1 bg-stone-300 mx-auto mb-8"></div>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Pomagamy sprzedawać i organizować pobyt. Oferujemy kompleksowe wsparcie dla polskich agencji turystycznych – od materiałów promocyjnych po logistykę i szybki kontakt.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {b2bServices.map((service, index) => (
            <div key={index} className="bg-stone-50 rounded-lg p-6 hover:shadow-lg transition-shadow">
              <div className="w-14 h-14 flex items-center justify-center bg-stone-800 rounded-full mb-4">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-medium text-stone-800 mb-3">{service.title}</h3>
              <p className="text-stone-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
